import { AppFlex } from 'shared/UI/UIKit/Flex';
import {
  MaxLessonsPerDayDelete,
  MaxLessonsPerDayEdit,
  MaxLessonsPerDayCopy,
  MaxLessonsPerDayView,
} from 'entities/max-lessons-per-day';
import type { ColumnsType } from 'antd/es/table';
import type { MaxLessonsPerDay } from 'shared/api';

export const getColumns = ({
  refreshTable,
}: {
  refreshTable: () => void;
}): ColumnsType<MaxLessonsPerDay> => [
  {
    key: 'name',
    title: 'Название',
    dataIndex: ['name'],
  },
  {
    key: 'actions',
    title: '',
    dataIndex: [],
    width: '250px',
    render: (_, record: MaxLessonsPerDay) => (
      <AppFlex direction="row" alignItems="center">
        <MaxLessonsPerDayView maxLessonsPerDay={record} />
        <MaxLessonsPerDayEdit maxLessonsPerDay={record} refreshTable={refreshTable} />
        <MaxLessonsPerDayCopy maxLessonsPerDay={record} refreshTable={refreshTable} />
        {!record.isBaseConfiguration && (
          <MaxLessonsPerDayDelete maxLessonsPerDay={record} refreshTable={refreshTable} />
        )}
      </AppFlex>
    ),
  },
];
